import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { RightOutlined } from '@ant-design/icons';
import event from '~helpers/mixpanel';
import { Light } from 'common/components/svgs';
import TutorialModal from '~components/pms-header/tutorial-modal';

const useStyles = makeStyles(theme => ({
  title: {
    display: 'inline-block',
    fontSize: '18px',
    lineHeight: '24px',
    color: theme.colors.captionColor,
    fontWeight: 400,
  },

  noticeWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '0 7px',
    height: 24,
    lineHeight: '24px',
    marginLeft: 12,
    borderRadius: '16px',
    cursor: 'pointer',
    backgroundColor: '#fff8da',
  },

  light: {
    marginRight: 4,
  },

  text: {
    ...theme.typography.body5,
    color: theme.colors.bodyColor,
  },
}));

const CounterOfferNotice = ({ title, from }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [visible, setVisible] = useState(false);

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>{title}</h2>
      <div
        className={classes.noticeWrapper}
        onClick={() => {
          if (from !== 'Edit Offer Page') {
            event('Clicked Counter Offer Settings', {
              'Clicked Position': 'Learn About Counter Offer',
              'Current Page Type': from,
            });
          }

          setVisible(true);
        }}
      >
        <Light className={classes.light} />
        <span className={classes.text}>{t('landlord.booking.counter_offer.notice.learn')}</span>
        <RightOutlined style={{ fontSize: 10, marginLeft: 4 }} />
      </div>

      <TutorialModal t={t} visible={visible} onCancel={() => setVisible(false)} from={from} />
    </div>
  );
};

export default CounterOfferNotice;
